import { useMutation } from "react-query";
import { usePopup } from "../../common/contexts/PopupContext";
import useOrganization from "../../common/hooks/pages/useOrganization";
import OrganizationForm from "../components/OrganizationForm";
import { useAuth } from "../../common/contexts/AuthContext";
import { useNavigate } from "react-router-dom";

function OrganizationFormContainer() {
  const { fetchProfile, user } = useAuth();

  const { toast } = usePopup();

  const navigate = useNavigate();

  const { updateOrganization, deleteOrganization } = useOrganization();

  const { mutate: updateOrg, isLoading: isUpdating } = useMutation({
    mutationFn: updateOrganization,
    onSuccess: (res) => {
      const { message } = res?.data;
      fetchProfile();
      toast(message, "success");
    },
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while updating organization!";
      toast(message, "error");
    },
  });

  const { mutate: deleteOrg, isLoading: isDeleting } = useMutation({
    mutationFn: deleteOrganization,
    onSuccess: (res) => {
      const { message } = res?.data;

      toast(message, "success");

      navigate("/organization");
    },
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while updating organization!";
      toast(message, "error");
    },
  });

  const organizationName = user?.organizationAsOwner?.name;

  console.log("user", user);

  return (
    <OrganizationForm
      updateOrg={updateOrg}
      isUpdating={isUpdating}
      organizationName={organizationName}
      deleteOrg={deleteOrg}
      isDeleting={isDeleting}
    />
  );
}

export default OrganizationFormContainer;
